import { serverUrl } from './serverConfig'
import { genericError } from "../util/errorUtil"
export const acaDashboardCoachApi = async (sessionToken) => {
    try {
        const body = {
            "identity": "aca.dashboard.coach",
        }
        const dashboard = await fetch(
            serverUrl,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    "Content-Type": "application/json",
                    "x-application-id": "",
                    "x-session-token": sessionToken
                },
                body: JSON.stringify(body)
            }
        )
        return await dashboard.json();
    } catch (errors) {
        return genericError(1000, errors)
    }
}

export const acaDashboardPlayerApi = async (sessionToken) => {
    try {
        const body = {
            "identity": "aca.dashboard.player",
        }
        const dashboard = await fetch(
            serverUrl,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    "Content-Type": "application/json",
                    "x-application-id": "",
                    "x-session-token": sessionToken
                },
                body: JSON.stringify(body)
            }
        )
        return await dashboard.json();
    } catch (errors) {
        return genericError(1000, errors)
    }
}

// export const acaDashboardBatterApi = async (sessionToken) => {
//     try {
//         const body = {
//             "identity": "aca.dashboard.batter",
//         }
//         const dashboard = await fetch(
//             "https://sbana.azurewebsites.net/api/dashboard",
//             {
//                 method: "POST",
//                 headers: {
//                     'Accept': 'application/json, text/plain, */*',
//                     "Content-Type": "application/json",
//                     "x-application-id": "",
//                     "x-session-token": sessionToken
//                 },
//                 body: JSON.stringify(body)
//             }
//         )
//         return await dashboard.json();
//     } catch (errors) {
//         return genericError(1000, errors)
//     }
// }

export const acaDashboardBowlerApi = async (sessionToken) => {
    try {
        const body = {
            "identity": "aca.dashboard.bowler",
        }
        const dashboard = await fetch(
            serverUrl,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    "Content-Type": "application/json",
                    "x-application-id": "",
                    "x-session-token": sessionToken
                },
                body: JSON.stringify(body)
            }
        )
        return await dashboard.json();
    } catch (errors) {
        return genericError(1000, errors)
    }
}

export const acaDashboardBatwkApi = async (sessionToken) => {
    try {
        const body = {
            "identity": "aca.dashboard.batwk",
        }
        const dashboard = await fetch(
            serverUrl,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    "Content-Type": "application/json",
                    "x-application-id": "",
                    "x-session-token": sessionToken
                },
                body: JSON.stringify(body)
            }
        )
        return await dashboard.json();
    } catch (errors) {
        return genericError(1000, errors)
    }
}

export const acaDashboardAllrApi = async (sessionToken) => {
    try {
        const body = {
            "identity": "aca.dashboard.allr",
        }
        const dashboard = await fetch(
            serverUrl,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    "Content-Type": "application/json",
                    "x-application-id": "",
                    "x-session-token": sessionToken
                },
                body: JSON.stringify(body)
            }
        )
        return await dashboard.json();
    } catch (errors) {
        return genericError(1000, errors)
    }
}